module.exports = __webpack_public_path__ + "static/media/volcano.8bf0d9e1.svg";